import '@babel/polyfill';
import '../biotrust/optin';
import '../biotrust/ytvideo';
import '../biotrust/trackers';
import '../biotrust/lockedInLanderCheckoutLinks';
import '../biotrust/vipSessionStorage';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/include/ls.include';
import 'lazysizes/plugins/progressive/ls.progressive';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import Player from '@vimeo/player';
import 'bootstrap'; // Debut Theme scripts

import '../vendor/debut';
import '../../styles/layout/lockedinlander.scss';
window.Vimeo = {
  Player: Player
};